import { AnalyticsEventProperties, AnalyticsEventValue } from 'core/analytics/entities';
import { AmplitudeService, AnalyticsService } from 'core/analytics/interfaces';

export class AnalyticsServerService implements AnalyticsService {
  constructor(private readonly amplitudeService: AmplitudeService) {}

  trackEvent(event: AnalyticsEventValue, properties?: AnalyticsEventProperties) {
    this.amplitudeService.trackEvent(event, properties);
  }

  setUserExperimentGroupName() {
    return;
  }

  getAttributionParameters() {
    return {
      fbp: '',
      fbc: '',
    };
  }

  getDeviceId() {
    return '';
  }

  getSessionId() {
    return '';
  }

  funnelOpened() {
    return null;
  }

  updateUserProperties() {
    return null;
  }

  setUserAge() {
    return null;
  }

  optOtSellUserData() {
    return null;
  }

  setUserId() {
    return null;
  }

  addUserAssociatedId(associatedId: string) {
    this.amplitudeService.setUserProperties({ associated_id: associatedId });
  }

  setIsUserTester() {
    return null;
  }

  paymentPlanChosen() {
    return null;
  }

  paymentFormOpened() {
    return null;
  }

  techPageOpened() {
    return null;
  }

  trackPaymentFormState() {
    return null;
  }

  paymentMethodClose() {
    return null;
  }

  paymentError() {
    return null;
  }

  async paymentSuccess() {
    return null;
  }

  paymentRetryScreenOpened() {
    return null;
  }

  paymentRetryTryAgainClicked() {
    return null;
  }

  paymentRetryCloseClicked() {
    return null;
  }

  viewSubscriptions() {
    return null;
  }

  addToCart() {
    return null;
  }

  initiateCheckout() {
    return null;
  }

  addEmail() {
    return null;
  }

  purchaseSucceed() {
    return null;
  }

  upsellPremiumScreenOpened() {
    return null;
  }

  consultationUpsellScreenOpened() {
    return null;
  }

  readingsPackUpsellScreenOpened() {
    return null;
  }

  consultationUpsellWithDiscountScreenOpened() {
    return null;
  }

  readingsPackUpsellWithDiscountScreenOpened() {
    return null;
  }

  upsellPremiumScreenClicked() {
    return null;
  }

  upsellPremiumScreenGetReport() {
    return null;
  }

  phoneNumberScreenOpen() {
    return null;
  }

  phoneNumberScreenAdd() {
    return null;
  }

  phoneNumberScreenSkip() {
    return null;
  }

  natalChartUpsellGetReport() {
    return null;
  }

  addUserId() {
    return null;
  }

  setFeatureFlagsAttributes() {
    return null;
  }

  async displayPaywallConditions() {}

  async acceptConditions() {}
}
